import JWTHelper from '@/jwt-token';
import * as moment from 'moment';
  
  export default {
    /* eslint-disable */
    name: 'ExtendedServiceInformation',
    props: {
      action: {},
      arrayLength: {},
      index: {},
      signature: {
        type: Boolean,
        required: false
      },
      showTooltip: {},
      student: {},
      supervisorFlagsArray: {},
      v: {},
      validateForm: {}
    },
    data() {
      return {
        checkedCreate: false,
        checked: false,
        supervisorChecked: true,
        supervisorChecked2: false,
        saveOptions: '',
        disabled: false,
        disabled2: false,
        disabledCopy: false,
        providerCheckCopy: false,
        componentKey: 0,
        edited: false,
      };
    },
    computed: {
      isMobile() {
        return this.$mq === 'mobile';
      },
      isEditingOrCopying() {
        return this.action === 'undefined' || this.action === 'copy';
      },
      isCopying() {
        return this.action === 'copy';
      },
      checkedErrors() {
        const errors = [];
        const licenseAttestUserId = this.v.licenseAttestUserId;
        if (!licenseAttestUserId.$dirty) return errors;
        if (!licenseAttestUserId.required) errors.push('Provider signature is required.');
        return errors;
      },
      supervisorCheckedErrors() {
        const errors = [];
        const supervisorUserId = this.v.supervisorUserId;
        // TODO: add back in when supervisor is required
        // if(this.supervisorFlagsArray.canSupervise && this.supervisorFlagsArray.supervisorRequiredFlag){
        // if (!supervisorUserId.$dirty) return errors;
        // if (!supervisorUserId.required) errors.push('Supervisor signature is required.');
        // }
        // return errors;
      },
      supervisorDisabled(){
        // can supervise
        if (this.supervisorFlagsArray.canSupervise) {
          if (this.supervisorChecked2) {
            this.disabled2 = true;
          }
          else {
            this.disabled2 = false;
          }
        }
        // can't supervise
        else {
          this.disabled2 = true;
        }
        return this.disabled2;
      },
      supervisorDisabled2(){
        // can supervise
        if (this.supervisorFlagsArray.canSupervise) {
          if (this.supervisorChecked) {
            this.disabled = true;
          }
          else {
            this.disabled = false;
          }
        }
        // can't supervise
        else {
          this.disabled = true;
        }
        return this.disabled;
      },
      needLevelAbsent(){
        if (this.student.form.serviceInformation.absentType === 'ABSENT_PRV' || this.student.form.serviceInformation.absentType === 'ABSENT_STU') {
          return true;
        }
        else {
          return false;
        }
      }
    },
    mounted() {
      this.componentKey += 1;
      if (this.isCopying) {
        this.providerCheckCopy = false;
        this.student.form.serviceInformation.licenseAttestUserId = null;
        this.student.form.serviceInformation.licenseAttestDate = null;
        this.student.form.serviceInformation.licenseAttestName = null;
        this.student.form.serviceInformation.licenseAttestFlag = false;
      }
    },
    methods: {
      convertDisplayedDate(date) {
        const year = date.substring(0, 4);
        const month = date.substring(5, 7);
        const day = date.substring(8, 10);
        // eslint-disable-next-line
        return month + '/' + day + '/' + year;
      },
      getCurrentDate() {
        const testDate = new Date().toLocaleDateString('en-US', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
        return testDate;
      },
      emitRemoveRecordClicked() {
        Swal.fire({
          text: 'Are you sure you want to delete this record?',
          confirmButtonText: 'Delete',
          showCancelButton: true,
          customClass: {
            popup: 'popup-class',
            content: 'content-class',
            confirmButton: 'confirm-button-class delete'
          }
        }).then((response) => {
          if (response && response.value) this.$emit('delete:record', { index: this.index });
        });
      },
      calcDate() {
        if (!this.edited) {
          return this.convertDisplayedDate(this.student.form.serviceInformation.supervisorDate);
        } else {
          return this.getCurrentDate();
        }
      },
      providerDisabled(){
        // check if provider info exists
        if (this.student.form.serviceInformation.licenseAttestUserId) {
          return true;
        }
        else {
          return false;
        }
      },
      handleTextTrimming(field, value) {
        if (value !== null && value !== undefined) {
          const trimmed = value.trim();
          this.student.form.serviceInformation[field] = trimmed;
        }
      },
      handleTextTrimmingRequired(field, value) {
        this.v[field].$touch();
        if (value !== null && value !== undefined) {
          const trimmed = value.trim();
          this.student.form.serviceInformation[field] = trimmed;
        }
      },
      supervisorCredentialFill(){
        if (this.student.form.serviceInformation.supervisorCredential !== undefined) {
          return this.student.form.serviceInformation.supervisorCredential;
        }
        else if (this.supervisorFlagsArray.supervisorCredential !== undefined) {
          return this.supervisorFlagsArray.supervisorCredential;
        }
        else {
          return '';
        }
      },
      onUserCheckboxClicked() {
        this.checked = !this.checked;
        this.checkedCreate = true;
        this.student.form.serviceInformation.licenseAttestUserId = JWTHelper.user().userId;
        this.student.form.serviceInformation.licenseAttestDate = moment().format('YYYY-MM-DD');
        this.student.form.serviceInformation.licenseAttestName = JWTHelper.user().fullName;
        this.disabledCopy = false;
      },
      onUserCheckboxClickedCopy() {
        this.student.form.serviceInformation.licenseAttestUserId = JWTHelper.user().userId;
        this.student.form.serviceInformation.licenseAttestDate = moment().format('YYYY-MM-DD');
        this.student.form.serviceInformation.licenseAttestName = JWTHelper.user().fullName;
        this.disabledCopy = true;
        this.providerCheckCopy = true;
        this.componentKey += 1;
  
        // null out supervisor attest info
        this.student.form.serviceInformation.supervisorUserId = null;
        this.student.form.serviceInformation.supervisorName = null;
        this.student.form.serviceInformation.supervisorCredential = null;
        this.student.form.serviceInformation.supervisorDate = null;
      },
      onSupervisorCheckboxClicked() {
        this.supervisorChecked = !this.supervisorChecked;
        this.student.form.serviceInformation.supervisorUserId = JWTHelper.user().userId;
        this.student.form.serviceInformation.supervisorName = JWTHelper.user().fullName;
        this.student.form.serviceInformation.supervisorCredential = JWTHelper.user().credentialName;
        this.student.form.serviceInformation.supervisorDate = moment().format('YYYY-MM-DD');
        this.disabled2 = true;
      },
      onSupervisorCheckboxClicked2() {
        this.supervisorChecked2 = !this.supervisorChecked2;
        this.student.form.serviceInformation.supervisorUserId = JWTHelper.user().userId;
        this.student.form.serviceInformation.supervisorName = JWTHelper.user().fullName;
        this.student.form.serviceInformation.supervisorCredential = JWTHelper.user().credentialName;
        this.student.form.serviceInformation.supervisorDate = moment().format('YYYY-MM-DD');
        this.disabled = true;
      }
    },
    watch: {
      'student.form.serviceInformation.licenseAttestUserId': {
        handler() {
          if (this.student.form.serviceInformation.licenseAttestUserId === null) {
            this.checkedCreate = false;
            this.checked = true;
            this.disabledCopy = false;
            this.providerCheckCopy = false;
          }
        }
      },
      'student.form.serviceInformation.supervisorUserId': {
        handler() {
          if (this.student.form.serviceInformation.supervisorUserId === null) {
            this.supervisorChecked = false;
            this.supervisorChecked2 = false;
            this.disabled = false;
            this.disabled2 = false;
            this.edited = true;
          }
        }
      },
    }
  };



// WEBPACK FOOTER //
// ./src/components/service-log/form/extended-service-information/extended-service-information.js